import { TrialStatus } from '@/reducers/auth/userReducer'
import {
  selectIsInUnservicedFreeTrial,
  getFreeTrialStatus,
} from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { Alert } from '@/ui'

export const FreeTrialUnreviewedAlert = () => {
  const trialStatus = useReselector(getFreeTrialStatus)
  const isFreeTrial = trialStatus === TrialStatus.active
  const isInUnservicedFreeTrial = useReselector(selectIsInUnservicedFreeTrial)
  if (!isFreeTrial || !isInUnservicedFreeTrial) return null
  return (
    <Alert
      variant="warning"
      title="Your financial transactions are unreviewed"
      description="Heads up! Because you are on a free trial, the numbers you are looking at have not been reviewed by Heard. While they give you a general picture of where your practice stands, we recommend joining Heard to receive a full review."
    />
  )
}
